/* WIJ(N) — subtle interactions. No frameworks, keeps things calm and fast. */
(function () {
  'use strict';

  // Fade-in on scroll for anything marked .reveal
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  // Mobile nav toggle
  const navToggle = document.querySelector('[data-nav-toggle]');
  const siteNav = document.querySelector('[data-site-nav]');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', () => {
      const isOpen = siteNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  // Product gallery thumbnail swap
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.dataset.fullSrc || thumb.src;
        thumbs.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });

  // Newsletter form: basic client-side feedback (Shopify handles the POST natively)
  document.querySelectorAll('[data-newsletter-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.dataset.loadingText || '...';
      }
    });
  });
})();


(function () {
  function initStickyHeader() {
    var wrap = document.getElementById('shopify-section-header');
    var header = document.querySelector('.site-header');
    var barWrap = document.getElementById('shopify-section-announcement-bar');
    var bar = barWrap ? barWrap.querySelector('.announcement-bar') : null;
    if (!wrap || !header) return;

    function setFixed(on) {
      header.classList.toggle('is-fixed', on);
      if (bar) bar.classList.toggle('is-fixed', on);
      header.style.top = (on && bar) ? bar.offsetHeight + 'px' : '';
    }
    function measure() {
      if (header.classList.contains('is-fixed')) return;
      wrap.style.minHeight = '';
      wrap.style.minHeight = wrap.offsetHeight + 'px';
      if (barWrap) {
        barWrap.style.minHeight = '';
        barWrap.style.minHeight = barWrap.offsetHeight + 'px';
      }
    }
    function update() {
      setFixed(wrap.getBoundingClientRect().bottom <= 0);
    }

    measure();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('load', function () { measure(); update(); });
    window.addEventListener('resize', function () {
      setFixed(false);
      measure();
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyHeader);
  } else {
    initStickyHeader();
  }
})();